import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useEffect } from "react";
import { Plus } from "lucide-react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import MixAndMatchListTabs from "@/components/menu-management/mix-and-match/mix-and-match-list/mix-and-match-list-tabs";
import MixAndMatchDraftListTabs from "@/components/menu-management/mix-and-match/mix-and-match-list/draft-list-tabs";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllMixAndMatches,
  clearMixAndMatchMessages,
} from "@/redux/slice/menu-manage-slice/mix-and-match-slice";
import useAuth from "@/hooks/useAuth";
import TableSkeleton from "@/components/skeleton/table-skeletion";

function MixAndMatch() {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const { getLoading } = useSelector(
    (state) => state.menuManage.mixAndMatch
  );

  useEffect(() => {
    if (user?.restaurant_id) {
      dispatch(fetchAllMixAndMatches(user.restaurant_id));
      dispatch(clearMixAndMatchMessages());
    }
  }, [dispatch, user?.restaurant_id]);

  if (getLoading) return <TableSkeleton links={backofficeLinks} />;

  return (
    <Layout2
      pageName={{ title: "Mix & Match Management" }}
      paths={[
        { name: "Home", path: "/home" },
        { name: "Back Office", path: "/backoffice/overview" },
        { name: "Menu Management", path: "/backoffice/menu/overview" },
        {
          name: "Mix & Match",
          path: "/backoffice/menu/mix-and-match",
        },
      ]}
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
    >
      <div className="container flex flex-col gap-4 mt-5">
        <div className="flex justify-between items-center w-full">
          <div>
            <h2 className="text-xl font-bold text-cwhite">Mix & Match</h2>
            <p className="text-xs text-cwhite3">
              Manage custom mix and match meal combinations and categories
            </p>
          </div>
          <Link to={"/backoffice/menu/mix-and-match/create"}>
            <Button className="flex items-center gap-1.5 bg-cyellow text-black hover:bg-cyellow/90 font-medium">
              <Plus size={18} /> Create Mix & Match
            </Button>
          </Link>
        </div>

        <Tabs
          defaultValue="mix-match-list"
          className="bg-transparent relative"
        >
          <TabsList className="grid grid-cols-6 w-full sm:w-[320px] bg-cblack3 border border-cblack6">
            <TabsTrigger
              className="col-span-3 data-[state=active]:bg-cyellow data-[state=active]:text-black text-cwhite"
              value="mix-match-list"
            >
              Mix & Match List
            </TabsTrigger>
            <TabsTrigger
              className="col-span-3 data-[state=active]:bg-cyellow data-[state=active]:text-black text-cwhite"
              value="draft"
            >
              Draft List
            </TabsTrigger>
          </TabsList>
          <Separator className="mt-3 w-full h-[1px] bg-cblack6" />
          <MixAndMatchListTabs />
          <MixAndMatchDraftListTabs />
        </Tabs>
      </div>
    </Layout2>
  );
}

export default MixAndMatch;
